const getters = {
  showLoader: state => state.system.showLoader,
  alertMessage: state => state.system.alertMessage,
  loaderMessage: state => state.system.loaderMessage,
  showAlert: state => state.system.showAlert,
  alertColor: state => state.system.alertColor,
  permission: state => state.user.permission,
  googleMapApiKey: state => state.user.googleMapApiKey,
  dateTimeFormate: state => state.user.dateTimeFormate,
  systemTopBarColor: state => state.system.systemTopBarColor,
  drawerToggle: state => state.system.drawerToggle,
  dialogToolbarColor: state => state.system.dialogToolbarColor,
  latitude: state => state.user.latitude,
  longitude: state => state.user.longitude,
  activeCallerWindow: state => state.user.activeCallerWindow
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js